import { formatMoney } from "~/utils/formatMoney"
import SummaryStat from "~/components/Admin/Reports/SummaryStat"
import { CampProps } from "~/interfaces"
import Slider from "react-slick"
import { iSiteSummaryReport } from "~/components/Admin/Reports/ReportsSites/index"

const SitesSummarySection = ({
  summary,
  camp,
  isMobile,
}: {
  summary: iSiteSummaryReport
  camp: CampProps
  isMobile: boolean
}) => {
  const summaryStatItems = [
    <SummaryStat key="occupancy" label="Average site occupancy" value={summary && summary.avg_camp_occupancy} />,
    <SummaryStat
      key="revenue"
      label="Average revenue per site"
      value={summary && formatMoney(summary.avg_site_revenue, camp?.currency)}
    />,
  ]

  const sitesSliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    pauseOnFocus: true,
  }

  return (
    <div className="pt-2 pb-2 border-b border-gray-200 sticky top-0 z-[0] bg-white">
      {isMobile ? (
        <div className="w-full py-2 mb-4">
          <Slider {...sitesSliderSettings}>
            {summaryStatItems.map((item, index) => (
              <div key={index} className="px-2">
                {item}
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">{summaryStatItems}</div>
      )}
    </div>
  )
}

export default SitesSummarySection
